/**
 * 「ログイン状態を保持」(trustDevice) チェック時にログイン画面の email input を
 * 次回起動時に prefill するためだけの軽量 storage。
 *
 * セキュリティ方針:
 *   - email **のみ**を localStorage に保存する (UI/UX 用途、非機密)。
 *   - master password / SK / refresh token は絶対に保存しない (CLAUDE.md §2 ルール 6)。
 *   - チェックを外して submit すると saved email を削除する。
 *   - private mode / quota / disabled storage 等で書き込みできない場合は
 *     in-memory のみで動作継続 (例外を握りつぶす)。
 *
 * 配置: 認証関連の軽量 utility のため `features/auth/services/` 配下。
 * UI prefill 以外の用途 (auto-login 等) には絶対に流用しないこと。
 */

const STORAGE_KEY = 'ookey.lastEmail'

const safeWindow = (): Window | null => (typeof window === 'undefined' ? null : window)

export const readRememberedEmail = (): string | null => {
  const w = safeWindow()
  if (w === null) return null
  try {
    const v = w.localStorage?.getItem(STORAGE_KEY)

    return v !== null && v !== undefined && v !== '' ? v : null
  } catch {
    return null
  }
}

export const writeRememberedEmail = (email: string): void => {
  const w = safeWindow()
  if (w === null) return
  const trimmed = email.trim()
  if (trimmed === '') {
    clearRememberedEmail()

    return
  }
  try {
    w.localStorage?.setItem(STORAGE_KEY, trimmed)
  } catch {
    // private mode / quota / disabled — UX 用途のため握りつぶす。
  }
}

export const clearRememberedEmail = (): void => {
  const w = safeWindow()
  if (w === null) return
  try {
    w.localStorage?.removeItem(STORAGE_KEY)
  } catch {
    // 同上。
  }
}
